import React from 'react';

import { InputText } from '../InputText';
import { InputTextArea } from '../InputTextArea';
import { SeparateLabel } from '../SeparateLabel';
import { ContainerInline } from './styles';

const TrainingParamsFields: React.FC = () => (
  <>
    <SeparateLabel label="Quantidade de séries" />
    <ContainerInline>
      <InputText type="number" label="De" name="sets_min" />
      <InputText type="number" label="Até" name="sets_max" />
    </ContainerInline>

    <SeparateLabel label="Quantidade de repetições" />
    <ContainerInline>
      <InputText type="number" label="De" name="reps_min" />
      <InputText type="number" label="Até" name="reps_max" />
    </ContainerInline>

    <SeparateLabel label="Intervalo entre séries/repetições (segundos)" />
    <ContainerInline>
      <InputText type="number" label="De" name="interval_min" />
      <InputText type="number" label="Até" name="interval_max" />
    </ContainerInline>

    <SeparateLabel label="Informações adicionais" />
    <InputTextArea
      name="additional_information"
      placeholder="Insira aqui alguma informação adicional desse exercício para este aluno."
    />
  </>
);

export { TrainingParamsFields };
